import * as React from 'react';
import {
  HTMLProps,
  ReactNode,
  Ref,
  forwardRef,
  MouseEventHandler
} from 'react';
import cn from 'classnames';
import '@mos-utils/css/lib/typography/Button.css';

export enum SIZE {
  big = 'big',
  standard = 'standard',
  small = 'small'
}

const Button = forwardRef(function Button(
  {
    primary = false,
    disabled = false,
    size = SIZE.standard,
    mobileFixed = false,
    className,
    children,
    ...props
  }: Props,
  ref: Ref<HTMLButtonElement>
): JSX.Element {
  return (
    <button
      ref={ref}
      type="button"
      {...props}
      disabled={disabled}
      className={cn(
        'mos-button',
        primary ? 'mos-button_type_primary' : 'mos-button_type_secondary',
        { 'mos-button_disabled': disabled },
        { 'mos-button_mobileFixed': mobileFixed },
        `mos-button_size_${size}`,
        className
      )}
    >
      {children}
    </button>
  );
});

interface Props {
  onClick: MouseEventHandler;
  disabled?: HTMLProps<HTMLButtonElement>['disabled'];
  mobileFixed?: boolean;
  primary?: boolean;
  /**
   * Размер кнопки
   * @type {'big' | 'standard' | 'small'}
   */
  size?: SIZE;
  className?: string;
  children: ReactNode;
}

/**
 * @version ../package.json
 */
export default Object.assign(Button, { SIZE });
